module.exports = __webpack_public_path__ + "img/harvardlogo.7f9c27ad.svg";